import { useTranslation } from "react-i18next";

import { UpsertTournament } from "@/components/tournaments/upsert-tournament";

export function TournamentHeader() {
  const { t } = useTranslation(["tournaments"]);

  return (
    <div className="flex flex-col items-center justify-between gap-2 bg-neutral-700 p-3 sm:flex-row md:gap-4 md:rounded-xl md:px-4 md:py-5">
      <h1 className="text-lg font-medium text-white md:text-xl">
        {t("tournaments:my-tournaments")}
      </h1>
      <UpsertTournament />
    </div>
  );
}
